import React from 'react';

// helpers
import styled from 'styled-components';
import useTranslation from 'hooks/useTranslation';
import { FormValuesModel } from '../..';
import { FieldArray, FieldArrayRenderProps, useFormikContext } from 'formik';

// constants
import { MAX_EMAILS_COUNT } from 'constants/onboarding';

// components
import { AddButton } from '@ui';
import InfoTooltip from 'components/Tooltips/InfoTooltip';
import { SectionIntro } from '@ui';
import DivAlignCenter from 'components/Additional/DivAlignCenter';
import HideIfDisabledForm from '../../../../../HideIfDisabledForm';
import EmailAddressForm, {
  FormValuesModel as EmailAddressFormValuesModel,
} from '../../../../CRM/EmailAddressForm';

interface IProps {
  displayTooltipInTitle?: boolean;
}

const EmailsSection = ({ displayTooltipInTitle }: IProps) => {
  const { t } = useTranslation('onboarding');
  const { values } = useFormikContext<FormValuesModel>();

  const renderEmails = (arrayHelper: FieldArrayRenderProps) => {
    const newEmail: EmailAddressFormValuesModel = {
      type: null,
      value: '',
      primary: {
        status: false,
        canEdit: true,
      },
    };

    return (
      <>
        {values.emails.map((email, i) => (
          <EmailAddressForm
            key={i}
            fieldName={`emails.${i}`}
            canVerify={
              email.primary?.status &&
              values?.canVerifyPrimaryEmail &&
              !email.isVerified
            }
            removeCallback={() => arrayHelper.remove(i)}
          />
        ))}

        {values.emails.length < MAX_EMAILS_COUNT ? (
          <HideIfDisabledForm hideIfSubmitting>
            <AddButton onClick={() => arrayHelper.push(newEmail)}>
              {t('applicant_information.add_email_button')}
            </AddButton>
          </HideIfDisabledForm>
        ) : null}
      </>
    );
  };

  return (
    <>
      <SectionIntro
        gutterTop
        titleVariant="h4"
        title={
          displayTooltipInTitle ? (
            <DivAlignCenter>
              {t('applicant_information.email_address_section.title')}
              <StyledInfoTooltip
                tooltipContent={t(
                  'applicant_information.cannot_update_primary_email_address_tooltip',
                )}
              />
            </DivAlignCenter>
          ) : (
            t('applicant_information.email_address_section.title')
          )
        }
      />
      <FieldArray name="emails" render={renderEmails} />
    </>
  );
};

const StyledInfoTooltip = styled(InfoTooltip)`
  margin-left: ${({ theme }) => theme.marginSm};
`;

export default EmailsSection;
